import React from "react";
import { createRoot } from "react-dom/client"; // Import createRoot
import App from "./App";
import { CacheProvider } from "@emotion/react";
import { TssCacheProvider } from "tss-react";
import createCache from "@emotion/cache";

const nonce = "AM2aDsE1p8Ih6Te25RF6nQ==";
const muiCache = createCache({
  key: "mui",
  prepend: true,

  nonce: nonce,
});

const tssCache = createCache({
  key: "tss",
  nonce: nonce,
  prepend: true,
});
const container = document.getElementById("root");
const root = createRoot(container); // Create a root.

root.render(
  <React.StrictMode>
    <CacheProvider value={muiCache}>
      <TssCacheProvider value={tssCache}>
        <App />
      </TssCacheProvider>
    </CacheProvider>
  </React.StrictMode>
);
